// extracted by mini-css-extract-plugin
export default {"button":"button__1J2No"};